module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/cart-icon.275f21a9.svg";